import Typekey from '@/userManagement/Typekey';

export default class OrgSubType extends Typekey {
  static readonly group = new OrgSubType('group', 'Group', '');
}
